module.exports = __webpack_public_path__ + "static/media/Mobile_Data_DASHBOARD_E_ANALYTICS.f0887644.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/dashboardAnalytics/Mobile_Data_DASHBOARD_E_ANALYTICS.png
// module id = 62
// module chunks = 0